import { classesBuilder } from '@common/helpers';
import StarButton from '@components/Button/StarButton';

import { generateStars } from './helpers';
import { useStarRating } from './hooks';
import type { IStarRatingProps } from './types';

import style from './styles.module.scss';

const StarRating = ({
  initialRating = 0,
  starCount = 5,
  readOnly = false,
  onChange,
  title,
  subtitle,
}: IStarRatingProps) => {
  const { rating, onRatingComplete } = useStarRating({ initialRating, readOnly, onChange });

  const stars = generateStars(starCount);

  return (
    <div className={style.wrapper}>
      {title && <label className={style.label}>{title}</label>}
      {subtitle && <div className={style.subtitle}>{subtitle}</div>}

      <div className={style['stars-row']}>
        <div
          className={classesBuilder(style.stars, {
            [style['read-only']]: readOnly,
          })}
          role="radiogroup"
          aria-label={title || 'Rate us'}
        >
          {stars.map((value) => {
            return (
              <StarButton
                key={value}
                value={value}
                rating={rating}
                readOnly={readOnly}
                onRate={onRatingComplete}
              />
            );
          })}
        </div>
        <span className={style['rating-fraction']}>{`${rating}/${starCount}`}</span>
      </div>
    </div>
  );
};

export default StarRating;
